import { useQuery } from "react-query";
import { getCodeLevels } from "../../../../actions/Utilities/Common";

export const useCodeLevel = () => {
  return useQuery("GetCodeLevel", getCodeLevels, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
